import { render, staticRenderFns } from "./HrPayslipsYearStrip.vue?vue&type=template&id=01631d8e&scoped=true&"
import script from "./HrPayslipsYearStrip.vue?vue&type=script&lang=js&"
export * from "./HrPayslipsYearStrip.vue?vue&type=script&lang=js&"
import style0 from "./HrPayslipsYearStrip.vue?vue&type=style&index=0&id=01631d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01631d8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VSpacer})
